// extracted by mini-css-extract-plugin
var _1 = "GretaAIChatLockedState-moduleaccess__e7wbY";
var _2 = "GretaAIChatLockedState-moduleavatar__BN0K8 IconNG-moduleiconContainer__SxWZ0";
var _3 = "GretaAIChatLockedState-modulecontent__UsLm8";
var _4 = "GretaAIChatLockedState-moduledescription__C1um4";
var _5 = "GretaAIChatLockedState-moduleheading__FhW6v";
var _6 = "GretaAIChatLockedState-moduleroot__Q3hTn GretaAIChatMessageList-modulewrapper__G2lG9";
var _7 = "GretaAIChatLockedState-modulescroll__TfE4R GretaAIChatMessageList-modulelist__CLTt9";
var _8 = "GretaAIChatLockedState-modulesupport__NGz8Y AIButtonContainedDark-moduleaiButtonContainedDark__jzTWy";
export { _1 as "access", _2 as "avatar", _3 as "content", _4 as "description", _5 as "heading", _6 as "root", _7 as "scroll", _8 as "support" }
